import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_SCENE_IDS } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'A recap card is clicked to play a walkthrough scene again',
  name: 'agent_onboarding_scene_replayed',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The walkthrough scene the recap card plays again',
      name: 'scene_id',
      required: true,
      type: 'enum',
      values: [...AGENT_ONBOARDING_SCENE_IDS],
    },
  ],
};

export default META;
